<template>
  <div class="box box-info">
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <form>
      <div class="p-toolbar p-component mb-4">
      <div class="p-grid justify-content-end">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openBasic" icon="pi pi-plus" label="NEW" />
          </div>
        </div>
       </div>
       <div></div>
      <Dialog header="Leave Request" :visible.sync="displayBasic" @show="checkNepaliDateOrEnglish"
              :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <label for="employeeName">Employee Name</label>
            <!-- <InputText v-model="employeeName"  id="employeeName"/> -->
             <!-- <AutoComplete v-model="epmloyee" filterMatchMode='contains'
                 :suggestions="filteredEmployees" @complete="searchItem($event)"
                  field="name" ref="itm">
                 </AutoComplete> -->
                 <AutoComplete v-model="employee" filterMatchMode='contains'
                 :suggestions="filteredEmployees" @complete="searchItem($event)"
                  field="name" ref="itm">
                 </AutoComplete>
          </div>
          <div class="p-field p-col-12 p-md-6">

          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="fromDate">Date From</label>
            <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
            <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="fromDate" v-model="fromDate"/>
          </div>

          <div class="p-field p-col-12 p-md-6">
            <label for="toDate">Date To</label>
            <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
            <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="toDate"
                       v-model="toDate"/>
          </div>

          <div class="p-field p-col-12 p-md-6">
            <label for="remarks">Request Description</label>
            <Textarea v-model="remarks" cols="30" rows="5"  id="remarks"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="modeOfTravel">Mode of Travel</label>
            <!-- <Dropdown v-model="modeOfTravel" optionLabel="name" placeholder="Select Mode Of Travel"
                      :filter="true"
                      :showClear="true" id="modeOfTravel"/> -->
                      <select class="selectBox" v-model="travelMode">
              <option selected disabled value="">Select Mode</option>
              <option v-for="(tax,ind) in modeOfTravel" :key="ind">{{ tax.name }}</option>
            </select>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="travelPlace">Travel Place</label>
            <InputText v-model="travelPlace"  id="travelPlace"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="advanceAmount">Advance Request Amount</label>
            <!-- <InputText v-model="advanceRequestAmount"  id="advanceAmount"/> -->
            <InputNumber id="rate" v-model="advanceAmount" mode="decimal" onfocus="if (this.value === '0.00')
                                this.value = ''"   :minFractionDigits="2" :maxFracionDigits="4" />
                                
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="alternativeEmployee">Alternative Employee</label>
            <AutoComplete v-model="alternateEmployee" :suggestions="filteredEmployee"
                          @complete="searchAlternateEmployee($event)" field="name"
                          id="alternativeEmployee"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="message">Message To Alt Employee</label>
            <Textarea v-model="alternateMessageToEmployee" cols="5" rows="2"  id="message"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="notificationMailTo">Notification Mail To</label>
            <AutoComplete v-model="notificationMailTo"  id="notificationMailTo"/>
          </div>
          <div class="p-field p-col-12 p-md-6"></div>
        </div>
        
        <template #footer>
          <!-- <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6"> -->
              <Button class="p-button-raised" @click.prevent="addLeaveRequest" :label="!editing?'Add':'Update'"/>
              <Button class="p-button-raised p-button-info" v-if="!editing"
                      label="Add & New"/>
              <Button  class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
            <!-- </div>
          </div> -->
        </template>
      </Dialog>
    

       <DataTable :value="leaveEmployeeRequestList" :paginator="true" :rows="8" :filters="filters">
      <Column header="S.N" field=""/>
      <Column header="Name" :sortable="true" field="employeeName"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['employeeName']" />
        </template>
      </Column>
      <Column header="Date From" :sortable="true" field="fromDate"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['fromDate']" />
        </template>
      </Column>
      <Column header="Date To" :sortable="true" field="toDate"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['toDate']" />
        </template>
      </Column>
      <Column header="Alternative Employee" :sortable="true" field="alternateEmployeeName"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['alternateEmployeeName']" />
        </template>
      </Column>
      <Column header="Leave Type" :sortable="true" field="absenceType"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['absenceType']" />
        </template>
      </Column>
      <template #empty>No record found</template>
      <Column header="Action">
        <template #body="slotProps">
          <!-- Edit Button -->
          <Button icon="pi pi-pencil" class="p-button-raised p-button-success"
                  @click="editLeaveRequest(slotProps.data)" />
          <Button class="p-button-raised p-button-danger"
                  @click="openDeleteDialog(slotProps.data.id)" icon="pi pi-trash"/>
        </template>
      </Column>
    </DataTable>
    <DeleteDialog v-model="deleteDialog" @cancel="cancelDelete" @deleted="deleteLeaveRequest"/>

    </form>
  </div>
</template>
<script>
import Dialog from 'primevue/dialog'
import DeleteDialog from '../../../layout/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import InputNumber from 'primevue/inputnumber'
import Dropdown from 'primevue/dropdown'
import InputMask from 'primevue/inputmask'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import Textarea from 'primevue/textarea'
import AutoComplete from 'primevue/autocomplete'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
export default {
  name: 'leaveRequest',
  data() {
    return {
      displayBasic: false,
      employee: '',
      employeeName: '',
      employeeId: 0,
      advanceAmount: 0,
      remarks: '',
      notificationMailTo: '',
      alternateEmployee: '',
      modeOfTravelId: 0,
      travelMode: '',
      advanceRequestAmount: 0.0,
      filteredEmployee: null,
      alternateMessageToEmployee: '',
      travelPlace: '',
      loading: false,
      editing: false,
      holidayId: null,
      fromDate: null,
      toDate: null,
      employeeList: null,
      englishDateEnabled: true,
      filters: {},
      // modeOfTravel:{},
      modeOfTravel: [
        {name: 'Bus', code: 'Bus'},
        {name: 'Train', code: 'Train'},
        {name: 'Plane', code: 'Plane'}
      ],
      deleteDialog: false,
      filteredEmployees: null,
      employeeLists: []
    }
  },
  computed: {
    leaveEmployeeRequestList() {
      return this.$store.state.hr.leaveEmployeeRequestList
    }
  },
  mounted() {
    this.findEmployeeList()
    this.findLeaveRequestByEmployeeList()
  },
  methods: {
    async findLeaveRequestByEmployeeList() {
      await this.$store.dispatch('loadLeaveRequestByEmployeeList')
    },
    editLeaveRequest(data) {
      this.editing = true
      this.fromDate = data.fromDate
      this.toDate = data.toDate
      this.remarks = data.remarks
      this.alternateMessageToEmployee = data.alternateMessageToEmployee
      // this.employee: this.employee.id,
      // this.alternateEmployee = this.alternateEmployee.id,
      // this.modeOfTravelId: this.modeOfTravel.id,
      this.travelPlace = data.travelPlace
      this.notificationMailTo = data.notificationMailTo
      this.openBasic()
    },
    async addLeaveRequest() {
      if (this.modeOfTravel === undefined) {
        this.modeOfTravel == null
        this.modeOfTravelId === 0
      } else {
        this.modeOfTravelId === this.modeOfTravel.id
      }
      let leaveRequest = {
        id: this.leaveRequest,
        fromDate: this.fromDate,
        toDate: this.toDate,
        remarks: this.remarks,
        alternateMessageToEmployee: this.alternateMessageToEmployee,
        employee: this.employee.id,
        alternateEmployee: this.alternateEmployee.id,
        modeOfTravelId: this.modeOfTravel.id,
        travelPlace: this.travelPlace,
        notificationMailTo: this.notificationMailTo
      }
      let response = ''
      try {
        if (!this.editing) {
          this.loading = true
          response = await this.$store.dispatch('createLeaveRequest', leaveRequest)
          this.loading = false
        } else {
          this.loading = true
          response = await this.$store.dispatch('updateLeaveRequest', leaveRequest)
          this.loading = false
        }
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
        }
      } catch (e) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 3000})
        this.loading = false
        return
      }
      this.reset()
    },
    reset() {
      this.name = ''
      this.displayBasic = false
    },
    openBasic() {
      this.displayBasic = true
    },
    cancelDelete(data) {
      this.deleteDialog = false
    },
    cancel() {
      this.displayBasic = false
    },
    async deleteLeaveRequest(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete Reason cannot be empty!!', life: 3000})
        this.deleteDialog = true
        return
      }
      let employee = {
        id: this.employeeId,
        deleteReason: value
      }
      try {
        let response = await this.$store.dispatch('deleteLeaveRequest', employee)
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: 'Employee ' + response.data.message, life: 3000})
          this.deleteDialog = false
        }
      } catch (e) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Something went wrong!!', life: 3000})
        return
      }
    },
    checkNepaliDateOrEnglish() {
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
      }
      if (!this.$store.getters.englishDate ||
        this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      }
      if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
        this.setEnglishDate()
      }
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    async findEmployeeList() {
      try {
        let rep = await this.$store.dispatch('loadEmployeeList')
        this.employeeLists = rep.data.data
      } catch (e) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Employee Name cannot be empty!', life: 3000})
        return
      }
    },
    searchItem(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredEmployees = [...this.employeeLists]
        } else {
          this.filteredEmployees = this.employeeLists.filter((item) => {
            return item.employeeName.toLowerCase().includes(event.query.toLowerCase()) || item.employeeId.includes(event.query)
          })
        }
      }, 250)
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    Dialog,
    Button,
    InputText,
    Dropdown,
    InputMask,
    DatePicker,
    Textarea,
    AutoComplete,
    Column,
    DataTable,
    InputNumber,
    DeleteDialog
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// leaveRequest.vue?283d6ea2